import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'logo',
    templateUrl: './logo.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'logo',
})
export class LogoComponent {
    @Input() customClasses?: string = '';
    @Input() whiteLogo?: boolean = false;
}
